import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import Nav from './components/Nav';
import Footer from './components/Footer';
import ScrollTop from './components/ScrollTop';
import Home from './pages/Home';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import DeleteAccount from './pages/DeleteAccount';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollTop />
      <a className="skip" href="#main">
        Skip to content
      </a>
      <Nav />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/contact" element={<Contact />} />

        {/* Legacy URLs. Live store listings still point at these, so they
            redirect rather than 404. */}
        <Route
          path="/android_privacy_policy"
          element={<Navigate to="/privacy" replace />}
        />
        <Route
          path="/ios_privacy_policy"
          element={<Navigate to="/privacy" replace />}
        />
        <Route path="/privacy-policy" element={<Navigate to="/privacy" replace />} />
        <Route path="/privacy.html" element={<Navigate to="/privacy" replace />} />
        <Route path="/terms-of-service" element={<Navigate to="/terms" replace />} />
        <Route path="/delete" element={<Navigate to="/delete-account" replace />} />
        <Route
          path="/deleteaccount"
          element={<Navigate to="/delete-account" replace />}
        />
        <Route
          path="/:app/deleteaccount"
          element={<Navigate to="/delete-account" replace />}
        />
        <Route
          path="/:app/privacy"
          element={<Navigate to="/privacy" replace />}
        />

        <Route path="*" element={<NotFound />} />
      </Routes>

      <Footer />
      <div className="grain" aria-hidden="true" />
    </Router>
  );
}

export default App;
